<template>
  <el-card class="my-box-card">
    <el-tabs v-model="currTab" @tab-click="handleSwitch">
      <el-tab-pane label="全部" name="0"></el-tab-pane>
      <el-tab-pane label="待付款" name="1"></el-tab-pane>
      <el-tab-pane label="待收货" name="2"></el-tab-pane>
      <el-tab-pane label="已完成" name="3"></el-tab-pane>
    </el-tabs>
    <div style="margin-top: -62px;float: right;">
      <el-input
        v-model="search"
        style="width: 300px"
        placeholder="订单编号/产品名称"
      >
        <el-button slot="append" icon="el-icon-search"></el-button>
      </el-input>
    </div>
    <el-table
      :data="tableData"
      style="width: 100%">
      <el-table-column
        prop="entrustNo"
        label="订单编号"
        width="170">
      </el-table-column>
      <el-table-column
        prop="testProduct"
        label="产品名称">
      </el-table-column>
      <el-table-column
        prop="testCompany"
        label="下单时间"
        width="120">
      </el-table-column>
      <el-table-column
        prop="status"
        label="状态"
        align="center"
        v-if="currTab!=='3'"
        width="110">
        <template slot-scope="scope">
          <el-tag :type="scope.row.status | formatStatusType">{{scope.row.status | formatStatus}}</el-tag>
        </template>
      </el-table-column>
      <el-table-column
        prop="entrustDate"
        align="center"
        label="下单时间"
        width="100">
      </el-table-column>
      <el-table-column
        label="操作"
        align="center"
        width="200">
        <template slot-scope="scope">
          <el-button size="small" type="text" >查看委托书</el-button>
          <span v-if="scope.row.status==='00'">
            <el-divider direction="vertical"></el-divider>
            <el-button size="small" type="text" >继续付款</el-button>
          </span>
          <span v-if="scope.row.status==='03'">
            <el-divider direction="vertical"></el-divider>
            <el-button size="small" type="text" >发送样品</el-button>
          </span>
          <span v-if="scope.row.status==='06'">
            <el-divider direction="vertical"></el-divider>
            <el-button size="small" type="text" >查看进度</el-button>
          </span>
          <span v-if="scope.row.status==='07' || scope.row.status==='08' || scope.row.status==='10'">
            <el-divider direction="vertical"></el-divider>
            <el-button size="small" type="text" >查看报告</el-button>
            <el-divider direction="vertical"></el-divider>
            <el-button size="small" type="text" >反馈</el-button>
          </span>
          <span v-if="scope.row.status==='09'">
            <el-divider direction="vertical"></el-divider>
            <el-button size="small" type="text" >撤销反馈</el-button>
          </span>
        </template>
      </el-table-column>
    </el-table>
   <!-- <el-pagination
      layout="prev, pager, next"
      :total="50">
    </el-pagination>-->
  </el-card>
</template>

<script>
export default {
  name: 'myOrder',
  data: function () {
    return {
      currTab: '0',
      search: '',
      tableData: [],
      allData: []
    }
  },
  // 00 未付款 01 已付款待审核 02 付款完成 03 待发样品 04 平台待收样品 05 已收样待检测 06 检测中 07 已检测 08 待发送报告 09 反馈中 10 完成
  mounted: function () {
    this.tableData = this.allData.slice(0, 5)
  },
  filters: {
    // 00 未付款 01 已付款待审核 02 付款完成 03 待发样品 04 平台待收样品 05 已收样待检测 06 检测中 07 已检测 08 待发送报告 09 反馈中 10 完成
    formatStatus: function (val) {
      let statusArr = {
        '00': '未付款',
        '01': '已付款待审核',
        '02': '付款完成',
        '03': '待发样品',
        '04': '平台待收样品',
        '05': '已收样待检测',
        '06': '检验中',
        '07': '已检验',
        '08': '待发送报告',
        '09': '反馈中',
        '10': '完成'
      }
      return statusArr[val]
    },
    formatStatusType: function (val) {
      if (['01', '05', '08'].includes(val)) {
        return ''
      } else if (['02', '07', '10'].includes(val)) {
        return 'success'
      } else if (['04', '09'].includes(val)) {
        return 'warning'
      } else if (['00', '03', '09'].includes(val)) {
        return 'danger'
      }
    },
    formatProgressType: function (val) {
      if (val <= 50) {
        return ''
      } else {
        return 'success'
      }
    }
  },
  methods: {
    handleSwitch: function () {
      if (this.currTab === '0') {
        this.tableData = this.allData.slice(0, 5)
      } else if (this.currTab === '1') {
        this.tableData = this.allData.filter(item => {
          return item.status === '00'
        })
      } else if (this.currTab === '2') {
        this.tableData = this.allData.filter(item => {
          return item.status === '01' || item.status === '02' || item.status === '03' || item.status === '04' || item.status === '05'
        })
      } else if (this.currTab === '3') {
        this.tableData = this.allData.filter(item => {
          return item.status === '06'
        })
      } else if (this.currTab === '4') {
        this.tableData = this.allData.filter(item => {
          return item.status === '07' || item.status === '08' || item.status === '10'
        })
      } else if (this.currTab === '5') {
        this.tableData = this.allData.filter(item => {
          return item.status === '09'
        })
      }
    }
  }
}
</script>

<style scoped>

</style>
